import React, { useState } from "react";

export const Team = (props) => {
  // Saklar untuk menyimpan Head/Divisi yang sedang diklik
  const [activeHead, setActiveHead] = useState(null);

  // Mencari data anak buah dari Head yang sedang aktif/diklik
  const activeTeamData = props.data ? props.data.find(h => (h.divisi || h.name) === activeHead) : null;

  return (
    <div id="team" className="text-center">
      <div className="container">
        <div className="col-md-8 col-md-offset-2 section-title">
          <h2>Meet the Team</h2>
          <p>Klik profil salah satu Head kami untuk melihat tim di baliknya.</p>
        </div>
        
        <div id="row">
          {/* BARIS PERTAMA: 3 Orang (Formasi Utama) */}
          <div className="row">
            {props.data
              ? props.data.slice(0, 3).map((d, i) => {
                  const headKey = d.divisi || d.name;
                  const isVacant = d.name && d.name.toLowerCase().includes("vacant");
                  return (
                    <div 
                      key={`${headKey}-${i}`} 
                      className="col-md-3 col-sm-6 team"
                      style={{ float: "none", display: "inline-block", verticalAlign: "top" }}
                    >
                      {/* Kotak ini sekarang jadi tombol yang bisa diklik */}
                      <div 
                        className="thumbnail" 
                        onClick={() => setActiveHead(activeHead === headKey ? null : headKey)}
                        style={{ 
                          cursor: "pointer", 
                          transition: "all 0.3s ease",
                          // Memberi efek kotak merah menyala kalau dia sedang dipilih
                          boxShadow: activeHead === headKey ? "0 0 15px rgba(244, 3, 63, 0.5)" : "none",
                          transform: activeHead === headKey ? "scale(1.05)" : "scale(1)"
                        }}
                      >
                        <img src={d.img} alt="..." className="team-img" />
                        <div className="caption">
                          <h4 style={isVacant ? { fontStyle: "italic", color: "#888" } : {}}>{d.name}</h4>
                          <p>{d.job}</p>
                        </div>
                      </div>
                    </div>
                  );
                })
              : "loading"}
          </div>

          {/* BARIS KEDUA: 4 Orang (Formasi Utama) */}
          <div className="row">
            {props.data
              ? props.data.slice(3, 7).map((d, i) => {
                  const headKey = d.divisi || d.name;
                  const isVacant = d.name && d.name.toLowerCase().includes("vacant");
                  return (
                    <div key={`${headKey}-${i}`} className="col-md-3 col-sm-6 team">
                      <div 
                        className="thumbnail"
                        onClick={() => setActiveHead(activeHead === headKey ? null : headKey)}
                        style={{ 
                          cursor: "pointer", 
                          transition: "all 0.3s ease",
                          boxShadow: activeHead === headKey ? "0 0 15px rgba(244, 3, 63, 0.5)" : "none",
                          transform: activeHead === headKey ? "scale(1.05)" : "scale(1)"
                        }}
                      >
                        <img src={d.img} alt="..." className="team-img" />
                        <div className="caption">
                          <h4 style={isVacant ? { fontStyle: "italic", color: "#888" } : {}}>{d.name}</h4>
                          <p>{d.job}</p>
                        </div>
                      </div>
                    </div>
                  );
                })
              : "loading"}
          </div>
          
          {/* --- AREA SUB-TIM (Muncul di bawah kalau ada Head yang diklik) --- */}
          {activeTeamData && activeTeamData.members && activeTeamData.members.length > 0 && (
            <div 
              style={{ 
                marginTop: "50px", 
                padding: "30px 0", 
                borderTop: "2px dashed #eee", // Garis batas pemisah
                animation: "fadeIn 0.5s" 
              }}
            >
              <h3>Tim {activeTeamData.divisi || activeTeamData.name}</h3>
              <p style={{ marginBottom: "30px" }}>
                {activeTeamData.name && activeTeamData.name.toLowerCase().includes("vacant")
                  ? `Anggota divisi ${activeTeamData.divisi || ""} (Saat ini posisi Head sedang lowong/vacant)`
                  : `Anggota divisi di bawah kepemimpinan ${activeTeamData.name}`}
              </p>
              
              <div className="row">
                {activeTeamData.members.map((member, i) => (
                  <div 
                    key={`member-${i}`} 
                    className="col-md-3 col-sm-6 team"
                    style={{ float: "none", display: "inline-block", verticalAlign: "top" }}
                  >
                    <div className="thumbnail" style={{ padding: "10px", background: "#f9f9f9" }}>
                      <img 
                        src={member.img} 
                        alt="..." 
                        className="team-img" 
                        style={{ width: "auto", height: "150px" }} // Sedikit lebih kecil dari Head
                      />
                      <div className="caption">
                        <h4>{member.name}</h4>
                        <p>{member.job}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

        </div>
      </div>
    </div>
  );
};